import "./Dashboard.scss";
import CandidatesTable from "../../components/CandidatesTable/CandidatesTable";
import CreateCandidateButton from "../../components/CreateCandidateButton/CreateCandidateButton";
import Header from "../../components/Header/Header";
import Filters from "../../components/Filters/Filters";
import { HeaderContext } from "../../global-components/HeaderContext";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance.js";

function Dashboard() {
  const navigate = useNavigate();
  const {headerData, getHeaderData} = useContext(HeaderContext)
  const [recruiter, setRecruiter] = useState("");
  const [candidates, setCandidates] = useState([]);

  console.log(headerData)


  const getData = async () => {
    try {
      const response = await api.get("/api/candidates");
      const data = response.data;
      setRecruiter(data.recruiter);

      console.log(data.candidates)

      const obj = {};

      data.candidates.forEach((item) => {
        if (obj[item.candidate_id]) {
          obj[item.candidate_id].assessments.push({
            name: item.assessment_name,
            status: item.status,
            progress: item.progress,
            time_spent: item.time_spent,
            is_norm: item.is_norm,
            norm_group: item.norm_group_name,
            send_date: item.send_date,
            start_date: item.start_date,
            completion_date: item.completion_date,
          });
        } else {
          obj[item.candidate_id] = {
            name: item.candidate_name,
            last_name: item.last_name,
            email: item.email,
            assessments: [
              {
                name: item.assessment_name,
                status: item.status,
                progress: item.progress,
                time_spent: item.time_spent,
                is_norm: item.is_norm,
                norm_group: item.norm_group_name,
                send_date: item.send_date,
                start_date: item.start_date,
                completion_date: item.completion_date,
              },
            ],
          };
        }
      });

      console.log(Object.entries(obj));
      setCandidates(Object.entries(obj));
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    getData();
    getHeaderData(1);
  }, []);
  return (
    <>
      <Header 
      role={1} 
      name={headerData.recruiter_name}
      companyName={headerData.company_name} 
      />
      <div className="dashboard">
        <div className="top">
          <div>
            <h1>Candidates</h1>
            <Filters />
          </div>
          <div>
            <CreateCandidateButton refreshCandidates={getData} />
          </div>
        </div>
        <div className="main">
          <CandidatesTable candidates={candidates} />
        </div>
      </div>
    </>
  );
}

export default Dashboard;
